<template>
  <div class="legal-page">
    <iframe
      style="width: 100%; height: 600px"
      :src="privacyPolicyUrl"
      title="Privacy Policy"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
const PRIVACY_POLICY_URL = 'https://fun2ever-policy.com/royal-defense/view#royal-defense_privacy-policy';

export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      privacyPolicyUrl: PRIVACY_POLICY_URL,
    };
  },
};
</script>

<style lang="less" scoped>
.legal-page {
  box-sizing: border-box;
  min-height: 100vh;
  background: #fff;
  width: 60%;
  margin: 120px auto 80px;
  border-radius: 10px;
}

.legal-iframe {
  display: block;
  width: 100%;
  height: calc(100vh - 56px);
  border: 0;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue